import { render, staticRenderFns } from "./_side-drawer-view.vue?vue&type=template&id=6562dcdc&scoped=true"
import script from "./_side-drawer-view.vue?vue&type=script&lang=js"
export * from "./_side-drawer-view.vue?vue&type=script&lang=js"
import style0 from "./_side-drawer-view.vue?vue&type=style&index=0&id=6562dcdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6562dcdc",
  null
  
)

export default component.exports